/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RequestPhoneUpdateOtpDTO = {
    channel: RequestPhoneUpdateOtpDTO.channel;
    countryCode: RequestPhoneUpdateOtpDTO.countryCode;
    newPhoneNumber: string;
    /**
     * Delivery channel: SMS, WHATSAPP or VOICE_MESSAGE
     */
    platform: RequestPhoneUpdateOtpDTO.platform;
};

export namespace RequestPhoneUpdateOtpDTO {

    export enum channel {
        WEB = 'WEB',
        MOBILE = 'MOBILE',
        POS = 'POS',
    }

    export enum countryCode {
        NG = 'NG',
        GH = 'GH',
    }

    /**
     * Delivery channel: SMS, WHATSAPP or VOICE_MESSAGE
     */
    export enum platform {
        SMS = 'SMS',
        WHATSAPP = 'WHATSAPP',
        VOICE_MESSAGE = 'VOICE_MESSAGE',
        EMAIL = 'EMAIL',
    }


}
